module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0068.jpg?v=2072d2ca";